export default "__VITE_ASSET__Duo4uXNa__"